// @ts-nocheck
import { mapGetters } from 'vuex'

const mixin = {
  computed: {
    ...mapGetters('auth', [
      'userId',
      'userEmail',
      'userFullName',
      'userRole',
      'platformId',
      'platformName'
    ])
  },

  methods: {
    initPendo () {
      const allowedHosts = [
        'dev.weclever.co'
      ]
      const allowedExecution = allowedHosts.includes(location.hostname)

      if (!allowedExecution) {
        return
      }

      pendo.initialize({
        visitor: {
          id: this.userId,
          email: this.userEmail,
          full_name: this.userFullName,
          role: this.userRole,
          platform: `${this.platformName} (ID ${this.platformId})`
        },

        account: {
          id: 'ACCOUNT-UNIQUE-ID'
        }
      })
    }
  }
}

export default mixin
